import { useMutation, useQueryClient } from "@tanstack/react-query";
import carouselApi, { CAROUSEL_KEY, UploadCarouselParams } from "../../api/carouselApi";

export const useCreateCarouselHomepage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UploadCarouselParams) =>
      carouselApi.uploadCarousel(data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CAROUSEL_KEY });
    },
  });
};